import React from 'react';
import Slider from 'react-slick';
import './Basics.css';
import './Basics-Slideshow.css';

import IconImage from './../public/icon-image.svg';
import IconText from './../public/icon-text.svg';

const slideshowSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: false,
  arrows: false,
  adaptiveHeight: true
};

export const Slideshow = ({children}) =>
  <Slider {...slideshowSettings} className='Slideshow'>
    {children}
  </Slider>;

export const Paragraph = ({children, caption}) => (
  <div tabIndex={0} className={`Paragraph ${caption ? 'Paragraph--caption' : null}`}>{children}</div>
);

export const Title = ({children, compact, level}) => {
  const isCompact = compact ? 'Title--compact' : '';
  const titleLevel = level && typeof level === 'number' ? level-1 : 1;
  return [
    <h1 className={`Title ${isCompact} level-1`}>{children}</h1>,
    <h2 className={`Title ${isCompact} level-2`}>{children}</h2>,
    <h3 className={`Title ${isCompact} level-3`}>{children}</h3>,
    <h4 className={`Title ${isCompact} level-4`}>{children}</h4>
  ][titleLevel]
};

// TODO accessibility video fallback
export const Video = ({source, poster}) => (
  <div className='Video'>
    <video controls className='Video__element' poster={poster || require('./../public/video-poster.png')}>
      <source src={source} type="video/mp4"/>
    </video>
  </div>
);

//TODO Add copyright option
export const Image = ({source, title, caption}) =>
  (<div tabIndex={0} className='Image'>
    <img src={source} alt={title} title={title}/>
    {caption && <Paragraph caption>{caption}</Paragraph>}
  </div>
);

export const Icon = ({type}) => {
  const imageKeys = ['Slideshow', 'Bild', 'Film', 'Video', 'Bilder', 'Image', 'Bildergalerie', 'Bildstrecke'].indexOf(type) < 0;
  const result = imageKeys ? IconText : IconImage; 
  return <img className='Icon' alt={`icon type: ${type}`} src={result}/>;
}


// TODO
// - Quote (see Particle11, Particle16)



/** WEBPACK FOOTER **
 ** ./src/Basics.js
 **/